var exports = {
  "j": "issueFormTextField__aMedoP",
};

module.exports = exports;
